import { render, staticRenderFns } from "./TabManutencaoListagem.vue?vue&type=template&id=046b0760&"
import script from "./TabManutencaoListagem.vue?vue&type=script&lang=ts&"
export * from "./TabManutencaoListagem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports